<template>
    <div class="select-location">
        <select-course-country
            id="select-country"
            class="location-selector"
            :countries-json="countriesJson"
        ></select-course-country>
        <select-course-city
            class="location-selector"
            :cities-json="citiesJson"
        ></select-course-city>
    </div>
</template>

<script>
import SelectCourseCountry from './SelectCourseCountry.vue';
import SelectCourseCity from './SelectCourseCity.vue';

export default {
    props: {
        citiesJson: String,
        countriesJson: String,
    },

    methods: {
        buildLocationUrl(city) {
            let url = appData.page.vars.courseUrl.replace(
                'COUNTRY',
                city.country.slug_short
            );
            url = url.replace('CITY', city.slug);

            return url;
        },
    },

    components: {
        SelectCourseCountry,
        SelectCourseCity,
    },
};
</script>
